import { useEffect, useState, useCallback } from 'react';
import API from '../../api';
import { useToast } from '../../context/ToastContext';

export default function ManageUniversites() {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const { addToast } = useToast();

  const load = useCallback(() => {
    const params = new URLSearchParams();
    if (search.length >= 2) params.append('search', search);
    const q = params.toString();
    API.get(`universites/${q ? '?' + q : ''}`)
      .then((r) => setItems(r.data.results || r.data))
      .catch(() => addToast('Erreur chargement', 'error'));
  }, [search, addToast]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-building" /> Universités & Établissements</h2>
        <span className="badge-status badge-info">{items.length} résultats (source : fichier référentiel)</span>
      </div>

      <div className="filter-bar">
        <input
          type="text" placeholder="Rechercher par nom ou sigle…"
          value={search} onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Sigle</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr><td colSpan="2"><div className="empty-state"><i className="bi bi-building" /><p>Aucune université trouvée</p></div></td></tr>
            ) : items.map((u) => (
              <tr key={u.id}>
                <td>{u.nom}</td>
                <td><strong>{u.sigle}</strong></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
